// removed by extract-text-webpack-plugin
module.exports = {"Message":"_1rLFx1cesLeRkcKtDoNpA-","Title":"_2JSdiJEx26Yh7RUllEsNoT","Body":"_19mGTe-jWGCEkj3Ud7koo1"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Chat/Message/Message.css
// module id = 234
// module chunks = 0